import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import AppRouter from 'components/@layout/Router/AppRouter';
import initializeI18next from 'utilities/initialize-i18next';
import Config from './config';
import BaseAppProviders from './providers';

const msalInstance = new PublicClientApplication(Config.auth);

const App: React.FC = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <BaseAppProviders>
        <>
          <AppRouter />
        </>
      </BaseAppProviders>
    </MsalProvider>
  );
};

initializeI18next();

export default App;
